import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { CompaniesApiService, PricesApiService } from '@fleet-beat/api';
import { CompanyDto, GetOneDto } from '@fleet-beat/core';
import { AuthService, CompanyStoreService } from '@fleet-beat/shared';
import { catchError, map, Observable, of, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CompanyCanActivateGuard implements CanActivate {
  constructor(
    private api: CompaniesApiService,
    private auth: AuthService,
    private store: CompanyStoreService,
    private pricesApiService: PricesApiService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    if (!this.auth.authenticated) {
      this.router.navigate(['/']);
      return of(false);
    }
    const companyId = route.paramMap.get('id');

    if (!companyId) {
      this.auth.signOut();
      return of(false);
    }

    const params: GetOneDto = {
      include: 'subscription,price',
    };

    return this.api.getOne(companyId, this.auth.authHeaders, params).pipe(
      tap((company: CompanyDto) => {
        if (company) this.store.setCompany(company);
      }),
      map(() => true),
      catchError(() => {
        this.auth.signOut();
        return of(false);
      }),
    );
  }
}
